
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 8.239c0-3.443 2.705-6.2 6-6.2 3.296 0 6 2.757 6 6.2 0 3.442-2.704 6.198-6 6.198-3.295 0-6-2.756-6-6.198zM8 .706C3.932.706.667 4.097.667 8.24c0 4.14 3.265 7.532 7.333 7.532 4.069 0 7.334-3.391 7.334-7.532C15.334 4.097 12.069.706 8 .706zm-.53 7.85c-.103.252-.155.59-.155 1.016h1.167l.018-.278a1.25 1.25 0 01.396-.78l.37-.35c.288-.28.49-.534.606-.762.115-.23.173-.475.173-.733 0-.568-.178-1.007-.533-1.317-.356-.313-.856-.47-1.5-.47-.638 0-1.142.164-1.513.492-.367.329-.554.783-.56 1.363H7.26c.006-.243.076-.433.21-.57a.724.724 0 01.542-.21c.474 0 .711.258.711.771 0 .17-.045.333-.136.488-.092.152-.275.35-.552.597-.273.243-.462.49-.565.742zm-.082 1.914a.663.663 0 00-.205.5c0 .201.067.367.2.498.137.13.316.196.538.196.222 0 .4-.066.533-.196a.658.658 0 00.206-.497c0-.204-.07-.37-.21-.502a.724.724 0 00-.529-.2.74.74 0 00-.533.2z","fill":"#000","opacity":".2"}})])
          )
        }
      }
    